(ns shared.core.components.file-upload
  (:require [shared.core.components.dragon-drop :as dnd]
            [shared.core.components.icon :as icon]
            [shared.core.components.label :as label]
            [shared.core.loading :as loading]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [clojure.string :as s]))

(def image-content-types #{"image/png" "image/jpeg" "image/gif" "image/webp" "image/svg+xml"})

(defn image-upload [{:keys [form-path form-name]}]
  (let [form-val- (re/subscribe [:form/val- form-path form-name])
        dragging?* (re/ratom false)
        input-id (str "image-upload-" (name form-name) "-" (random-uuid))]
    (fn [{:keys [label label-info clearable? uploading? disabled? container-style on-file]}]
      [:div {:style (merge {:display :flex
                            :flex-direction :column
                            :flex 1}
                           (when disabled? {:opacity 0.5})
                           container-style)}
       (when label
         [label/label {:info-tooltip label-info} label])
       [dnd/dropzone {:dragging?* dragging?*
                      :file-types image-content-types
                      :on-file-type-drop-error #(re/dispatch [:toasts/add-error {:msg "Only PNG, JPEG, GIF, WEBP and SVG images are supported"}])
                      :on-drop #(when-not disabled?
                                  (some-> (.. % -dataTransfer -files) (aget 0) (on-file)))
                      :style {:display :flex
                              :align-items :center
                              :border (str "1px solid " (style/color :gray :base))
                              :border-radius 4
                              :padding 6}
                      :dragging-style (when-not disabled?
                                        {:border (str "1px dashed " (style/color :green :base))})}
        [:div {:style {:display :flex
                       :align-items :center
                       :justify-content :center
                       :height 40
                       :width 72
                       :margin-right 10
                       :border-radius 4
                       :background-color (style/color :gray :shade-7)}}
         (cond
           uploading?
           [loading/spinner {:size 18}]

           (not (s/blank? @form-val-))
           [:img {:src @form-val-
                  :style {:max-height 36
                          :max-width 68}}]

           :else
           [icon/material-icon {:icon-type :image
                                :style {:color (style/color :gray :base)}}])]
        [:input {:id input-id
                 :type :file
                 :accept (s/join "," image-content-types)
                 :disabled disabled?
                 :style {:display :none}
                 :on-change #(let [file (some-> % (.-target) (.-files) (aget 0))]
                               (set! (.. % -target -value) "")
                               (some-> file (on-file)))}]
        [:label {:for input-id
                 :style {:color (style/color :green :base)
                         :cursor (if disabled? :not-allowed :pointer)
                         :font-size 14}}
         (if (s/blank? @form-val-) "Choose Image" "Replace Image")]
        [:span {:style {:color (style/color :gray :base)
                        :font-size 12
                        :margin-left 8}}
         "or drop one here"]
        (when (and clearable? (not disabled?) (not (s/blank? @form-val-)))
          [icon/material-icon {:icon-type :close
                               :style {:margin-left :auto}
                               :on-click #(re/dispatch [:form/change form-path form-name nil])}])]])))
